import { OPTIONAL } from './../../constants/constant';
import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { FormControl, AbstractControl, Validators } from '@angular/forms';
import { Datepicker } from '../../models/datepicker.model';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { checkHTMLTags } from '../../validators/textPatternValidator';

@Component({
  selector: 'app-input-textbox',
  templateUrl: './input-textbox.component.html',
  styleUrls: ['./input-textbox.component.scss']
})
export class InputTextboxComponent implements OnInit, OnChanges, OnDestroy {

  @Input() labelName: string;
  @Input() disableComments = false;
  @Input() disablePostComments = false;
  @Input() labelTextTransformNone = false;
  @Input() inputFormControl: FormControl;
  @Input() placeHolder = 'Input Field Text';
  @Input() submitted = false;
  @Input() showDatePicker = false;
  @Input() showNoLabel = true;
  @Input() readOnlyMode = false;
  @Input() minDate: Datepicker;
  @Input() maxDate: Datepicker;
  @Output() focusInput = new EventEmitter();
  @Input() showCommentIcon = false;
  @Input() commentObject: any;
  @Input() tooltiptxt: string;
  @Input() showLabelName = true;
  @Input() showRequiredFieldWithoutLabel: string;
  @Input() showOptionalLabel = true;
  @Input() isGradeTable = false;
  @Output() onShowComment = new EventEmitter();
  @Output() onDateSelected = new EventEmitter();
  @Output() onValueChange = new EventEmitter();
  @ViewChild('inputBox') public inputBox: ElementRef;
  model: any;
  datePickermodel: NgbDateStruct;
  date: { year: number, month: number };
  showCalender = false;

  OPTIONAL = OPTIONAL;

  constructor() { }

  ngOnInit(): void {
    if (this.inputFormControl && this.inputFormControl.validator) {
      this.inputFormControl.setValidators([this.inputFormControl.validator, checkHTMLTags()]);
    } else {
      this.inputFormControl.setValidators([checkHTMLTags()]);
    }
    this.datePickermodel = new Datepicker();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.inputFormControl.valueChanges.subscribe((value) => {
      if (value && (value.length === 1) && (value === ' ')) {
        this.inputFormControl.setValue(null, { emitEvent: false });
      }
      this.onValueChange.emit();
    });
  }

  public onDateSelect(event): void {
    const day = event.day < 10 ? `0${event.day}` : `${event.day}`;
    const month = event.month < 10 ? `0${event.month}` : `${event.month}`;
    const date = `${day}/${month}/${event.year}`;
    this.inputFormControl.setValue(date);
    this.showCalender = false;
    this.inputFormControl.markAsTouched();
    this.inputFormControl.markAsDirty();
    this.onDateSelected.emit(event);
  }

  get isRequiredField(): boolean {
    if (!this.inputFormControl || !this.inputFormControl.validator) {
      return false;
    }

    const validator = this.inputFormControl.validator({} as AbstractControl);
    return (validator && validator.required);
  }

  getClasses(): string {
    if (this.inputFormControl &&
      (this.submitted || this.inputFormControl.touched) &&
      this.inputFormControl.errors) {
      if (this.showCommentIcon) {
        return 'error-input show-comment-input';
      }
      return 'error-input';
    } else {
      if (this.showCommentIcon) {
        return 'show-comment-input';
      }
      return '';
    }
  }

  public focusFunction(): void {
    this.focusInput.emit(true);
  }

  public focusOutFunction(): void {
    this.focusInput.emit(false);
  }

  public clickComment(): void {
    this.onShowComment.emit();
  }

  ngOnDestroy(): void {
    // this.inputFormControl.updateValueAndValidity();
  }
}
